
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import ContentItemForm from "./ContentItemForm";
import { ContentItemForm as ContentItemFormType } from "@/hooks/useLessonContent";

interface ContentItemDialogProps {
  isOpen: boolean;
  isCreating: boolean;
  lessonId: string;
  currentContentItem: ContentItemFormType;
  setCurrentContentItem: (item: ContentItemFormType) => void;
  onOpenChange: (open: boolean) => void;
  onSave: () => Promise<void>;
}

const ContentItemDialog: React.FC<ContentItemDialogProps> = ({
  isOpen,
  isCreating,
  lessonId,
  currentContentItem,
  setCurrentContentItem,
  onOpenChange,
  onSave
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {isCreating ? "Add Content Item" : "Edit Content Item"}
          </DialogTitle>
          <DialogDescription>
            {isCreating ? "Add a new content item to this lesson." : "Update content item details."}
          </DialogDescription>
        </DialogHeader>
        
        <ContentItemForm 
          currentContentItem={currentContentItem}
          setCurrentContentItem={setCurrentContentItem}
          lessonId={lessonId}
        />
        
        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button onClick={onSave}>
            {isCreating ? "Create Content" : "Update Content"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ContentItemDialog;
